export const JSON_ONE7NW = {

    "ag_id": "paygate",
    "me_id":"202205240004",
    "ag_ref": "ivWFaA+b6yo7gDBlXJ+dSSu38ecVo3hEWFJDMa2ffiM=",
    "refund_amount": "duvT/grttVHYPXZ6icv5xQ==",
    "refund_reason”": "pHhFd/cUICIkdL3MqrXxMA=="

}